<form class="mr-2">
	<div class="danger-subtitle-30">
		{{'global.org_settings.danger_zone.title' | translate}} - {{'global.org_settings.danger_zone.change_owner' | translate}}
	</div>
	<nz-form-item >
		<div class="container">
			<nz-select [nzServerSearch]="true" name="owner" [(ngModel)]="selectedValue" (ngModelChange)="showChangeOwnerModal()">
				<nz-option *ngFor="let option of listOfOptions" [nzLabel]="option" [nzValue]="option" name="option" >
				</nz-option>
			</nz-select>
		</div>
	</nz-form-item>
	<div class="danger-subtitle-30">
		{{'global.org_settings.danger_zone.title' | translate}} - {{'global.org_settings.danger_zone.delete' | translate}}
	</div>
	<button nz-button class="btn-danger border-radius-5" [nzType]="'Danger'" (click)="showDeleteModal()">
		<i nz-icon nzType="delete" nzTheme="outline"></i>{{'global.org_settings.danger_zone.delete' | translate}}
	</button>
</form>

<nz-modal [(nzVisible)]="deleteModalVisible" (nzOnCancel)="handleDeleteCancel()"
	[nzTitle]="deleteModalTitle" nzCenterd [nzStyle]="formModalStyle">
	<ng-template #deleteModalTitle class="font-800">
		<span class="color-grey">{{'global.org_settings.danger_zone.delete' | translate}} {{organizationName}}</span>
	</ng-template>
	<ng-container *nzModalContent>
		<div class="center">
			<form [formGroup]="deleteOrganizationForm" class="address-form">
				<nz-form-item class="input-field title-14">
					<nz-form-control>
						<app-input-field [size]="'large'" [form]="deleteOrganizationForm"
										 [label]="'global.org_settings.danger_zone.modal_title' | translate"
										 [placeholder]="'global.org_settings.danger_zone.modal_placeholder' | translate"
										 [formName]="'organizationName'"></app-input-field>
					</nz-form-control>
				</nz-form-item>
			</form>
		</div>
	</ng-container>
	<div *nzModalFooter>
		<button nz-button [disabled]="deleteOrganizationForm.invalid" class="btn-danger border-radius-5" [nzType]="'Danger'" (click)="handleDelete(deleteOrganizationForm)">
			<i nz-icon nzType="delete" nzTheme="outline"></i>{{'global.org_settings.danger_zone.delete' | translate}}
		</button>
	</div>

</nz-modal>

<nz-modal [(nzVisible)]="changeOwnerModalVisible"
		[nzStyle]="formModalStyle"
		[nzTitle]="changeOwnerTitle"
		(nzOnCancel)="handleChangeOwnerCancel()">
	<ng-template #changeOwnerTitle class="font-800">
		<span class="color-grey">{{'global.org_settings.danger_zone.change_owner' | translate}}: {{selectedValue}}</span>
	</ng-template>
	<ng-container *nzModalContent>
		<div class="center">
			<span class="color-grey">
				{{'global.org_settings.danger_zone.change_owner_info' | translate:{organization: organizationName, user: selectedValue} }}
			</span>
		</div>
	</ng-container>
	<div *nzModalFooter>
		<button nz-button nzType="default" class="color-grey border-none"
				(click)="handleChangeOwnerCancel()">{{'global.org_settings.danger_zone.cancel' | translate}}</button>
		<button nz-button nzType="default" class="border-radius-5 border-color-blue color-blue"
				(click)="handleChangeOwnerOk()">{{'global.org_settings.danger_zone.ok' | translate}}</button>
	</div>

</nz-modal>
